if (!customElements.get('product-options')) {
  customElements.define(
    'product-options',
    // eslint-disable-next-line no-undef
    class ProductOptions extends window.BAO.CustomElement() {
      connectedCallback () {
        super.connectedCallback()

        this.isStepped = !!this.getAttribute('data-steps-total')
        this.currentStep = 1
      }

      setupListeners () {
        super.setupListeners()

        if (!this.els.trigger || this.els.trigger.elements.length < 2) return

        this.handleTrigger = this.handleTrigger.bind(this)

        this.listeners.add(this, 'click', this.handleTrigger)
      }

      handleTrigger (event) {
        event.preventDefault()

        const trigger = event.target.closest(
          '[data-product-options-el="trigger"]',
        )
        if (!trigger) return

        trigger.setAttribute('aria-pressed', 'true')

        const optionIndex = trigger.dataset.index
        const optionValue = trigger.dataset.value

        const allIndexTriggerEls = [
          ...document.querySelectorAll(
            `${this.els.trigger.selector}[data-index="${optionIndex}"]`,
          ),
        ]

        allIndexTriggerEls.forEach(triggerEl => {
          triggerEl.setAttribute(
            'aria-pressed',
            (triggerEl === trigger).toString(),
          )
        })

        allIndexTriggerEls
          .filter(
            triggerEl => this.isQuickBuy(trigger) === this.isQuickBuy(triggerEl),
          )
          .forEach(triggerEl => {
            triggerEl.setAttribute(
              'aria-pressed',
              (triggerEl.dataset.value === optionValue).toString(),
            )
          })

        const allIndexSelectEls = [
          ...document.querySelectorAll(
            `${this.els.select.selector}[data-index="${optionIndex}"]`,
          ),
        ]

        allIndexSelectEls
          .filter(
            selectEl => this.isQuickBuy(trigger) === this.isQuickBuy(selectEl),
          )
          .forEach(selectEl => {
            selectEl.value = optionValue
            selectEl.dispatchEvent(new Event('change', { bubbles: true }))
          })

        if (this.isStepped && window.abTest576) {
          const totalSteps = parseInt(this.getAttribute('data-steps-total'))
          const isLastStep = this.currentStep >= totalSteps

          if (isLastStep) {
            this.handleFormSubmit()
          } else {
            this.currentStep += 1

            this.els.step.elements.forEach(el => {
              const step = parseInt(el.dataset.step)

              if (step === this.currentStep) {
                el.removeAttribute('hidden')
              } else {
                el.setAttribute('hidden', '')
              }
            })
          }
        }
      }

      handleFormSubmit () {
        if (!window.abTest576) return

        const availableButton = this.externalEls.quickbuyButtons.element.querySelector('button[aria-hidden="false"]')

        if (availableButton) {
          availableButton.click()
        }
      }

      isQuickBuy (element) {
        return !!element.closest('[data-section="product-quickbuy"]')
      }
    },
  )
}
